'use client'

import {
    META_LIMIT_LABELS,
    META_QUALITY_LABELS,
    WhatsappBroadcastMetaLimit,
    getWhatsappBroadcastMetaLimit,
} from '@/lib/api/messaging/whatsapp-broadcasts-api'
import { useEffect, useState } from 'react'
import { MdRefresh } from 'react-icons/md'

/** Limite de 24h e qualidade do número lidos na hora da Meta, e o que a conta já usou. */
export const MetaLimitCard = ({ departmentId, limitSharePercent }: { departmentId: number; limitSharePercent?: number }) => {
    const [data, setData] = useState<WhatsappBroadcastMetaLimit | null>(null)
    const [error, setError] = useState<string | null>(null)
    const [loading, setLoading] = useState(false)

    const load = () => {
        setLoading(true)
        setError(null)
        getWhatsappBroadcastMetaLimit(departmentId)
            .then(res => {
                if (res.success) setData(res.result)
                else setError(res.error || 'Não foi possível consultar a Meta.')
            })
            .catch(() => setError('Não foi possível consultar a Meta.'))
            .finally(() => setLoading(false))
    }

    useEffect(load, [departmentId])

    const quality = META_QUALITY_LABELS[(data?.qualityRating ?? 'UNKNOWN').toUpperCase()] ?? META_QUALITY_LABELS.UNKNOWN
    const share = data && limitSharePercent ? Math.floor((data.limit * limitSharePercent) / 100) : null

    return (
        <div className="rounded-lg border border-base-300 p-4">
            <div className="flex items-center justify-between gap-2 mb-3">
                <span className="text-sm font-semibold">Limite da Meta</span>
                <button type="button" className="btn btn-ghost btn-xs gap-1" onClick={load} disabled={loading}>
                    <MdRefresh size={14} /> Atualizar
                </button>
            </div>
            {loading && !data ? (
                <span className="loading loading-spinner loading-sm" />
            ) : error ? (
                <p className="text-sm text-error">{error}</p>
            ) : data ? (
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                    <div>
                        <div className="text-base-content/60 text-xs">Limite atual</div>
                        <div className="font-semibold">
                            {data.messagingLimit ? META_LIMIT_LABELS[data.messagingLimit] ?? data.messagingLimit : `${data.limit} / 24h`}
                        </div>
                    </div>
                    <div>
                        <div className="text-base-content/60 text-xs">Qualidade do número</div>
                        <span className={`badge badge-sm ${quality.color}`}>{quality.label}</span>
                    </div>
                    <div>
                        <div className="text-base-content/60 text-xs">Usado pela conta (24h)</div>
                        <div className="font-semibold tabular-nums">
                            {data.usedLast24h.toLocaleString('pt-BR')} de {data.limit.toLocaleString('pt-BR')}
                        </div>
                    </div>
                    {share != null && (
                        <div>
                            <div className="text-base-content/60 text-xs">Fatia deste disparo</div>
                            <div className="font-semibold tabular-nums">{share.toLocaleString('pt-BR')} / 24h</div>
                        </div>
                    )}
                </div>
            ) : null}
            <p className="text-xs text-base-content/60 mt-3">
                O limite é da conta inteira (todos os números) e conta contatos únicos que recebem template fora da
                janela de 24h. A Meta sobe o limite sozinha quando a conta usa boa parte dele com qualidade alta. O
                disparo pausa sozinho se a qualidade cair.
            </p>
        </div>
    )
}
